import moment from "moment";

const columns = {
  titles: [
    "Id",
    "Meter Number",
    "Meter Type",
    "Estate",
    "Added By",
    "Date Added",
    "Action"
  ],

  columns($: any) {
    return [
      { data: "id" },
      { data: "meterNumber" },
      { data: "meterType" },
      { data: "estate" },
      { data: "addedBy" },
      {
        data: "createdAt",
        render: function (data: string) {
          return moment(data).format("DD/MM/YYYY HH:mm a");
        }
      },
      {
        data: null,
        orderable: false,
        searchable: false,
        render: function (_: any, __: any, row: any) {
          return `
            <div style="cursor: pointer;" class="action-icon" data-id="${row.id}">
              &#8942; <!-- vertical ellipsis icon -->
            </div>
          `;
        }
      }
    ];
  }
};

export default columns;
